"use client";

import { Spinner } from "@oreme/ui";
import { useTranslations } from "next-intl";
import React, { type ReactElement } from "react";
import { BlurryEffect } from "@/components";

interface PageLoadingProps {
  title: string;
  lead: string;
}

function PageLoading({
  title,
  lead,
}: Readonly<PageLoadingProps>): ReactElement {
  const t = useTranslations("global.Loading");
  return (
    <div className="relative flex flex-col min-h-[calc(100svh-var(--globalnav-height))] bg-accent">
      <div className="flex-1 relative flex justify-center items-center overflow-hidden text-foreground">
        <header className="relative z-10 flex flex-col gap-2 max-w-md text-center">
          <h1 className="text-2xl font-semibold p-1 animate__animated animate__slideInUp animate__faster">
            {title}
          </h1>
          <hr className="border-0 h-px bg-linear-to-r from-transparent via-current to-transparent" />
          <div className="flex flex-col animate__animated animate__fadeIn animate__faster delay-0.5s p-1">
            <p className="text-sm leading-tight opacity-50">{lead}</p>
          </div>
        </header>
        <footer className="absolute bottom-0 right-0 p-4">
          <span className="flex flex-row text-sm gap-2 border rounded p-1">
            <Spinner /> {t("loading")}
          </span>
        </footer>
        <figure className="absolute z-10 inset-0">
          <BlurryEffect />
        </figure>
      </div>
    </div>
  );
}

export { PageLoading, type PageLoadingProps };
